/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const DELETE_PAYMENT_TOKEN = gql`
  mutation deletePaymentToken($id: ID!) {
    deletePaymentToken(id: $id) {
      success
    }
  }
`;
